(() => {

  if (window.BopAnalytics) return;



  /* =========================================================

     BOPLASTEMX ANALYTICS

     Version 1.3.1-cartfix

     ========================================================= */



  const VERSION = '1.3.1-cartfix';



  const SESSION_KEY = 'bop_analytics_session_v1';

  const ATTRIBUTION_KEY = 'bop_attribution_v1';

  const EVENT_LOG_KEY = 'bop_event_log_v1';



  const CONFIG_PREFIX = 'bop_configuration_v1_';

  const MILESTONE_PREFIX = 'bop_milestone_v1_';



  const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

  const MAX_LOCAL_EVENTS = 250;



  let publishQueue = [];

  let publishTimer = null;



  function now() {

    return Date.now();

  }



  function uuid() {

    if (

      window.crypto &&

      typeof window.crypto.randomUUID === 'function'

    ) {

      return window.crypto.randomUUID();

    }



    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'

      .replace(/[xy]/g, function(c) {

        const r = (Math.random() * 16) | 0;

        const v =

          c === 'x'

            ? r

            : (r & 0x3) | 0x8;



        return v.toString(16);

      });

  }



  function safeParse(value, fallback) {

    try {

      return JSON.parse(value);

    } catch (_) {

      return fallback;

    }

  }



  function safeStorageGet(storage, key) {

    try {

      return storage.getItem(key);

    } catch (_) {

      return null;

    }

  }



  function safeStorageSet(storage, key, value) {

    try {

      storage.setItem(key, value);

    } catch (_) {}

  }



  function getDeviceCategory() {

    const width =

      window.innerWidth ||

      document.documentElement.clientWidth ||

      0;



    if (width <= 749) return 'mobile';

    if (width <= 1024) return 'tablet';

    return 'desktop';

  }



  function getBrowser() {

    const ua = navigator.userAgent || '';



    if (/Edg/i.test(ua)) return 'Edge';



    if (

      /Chrome/i.test(ua) &&

      !/Edg/i.test(ua)

    ) {

      return 'Chrome';

    }



    if (

      /Safari/i.test(ua) &&

      !/Chrome/i.test(ua)

    ) {

      return 'Safari';

    }



    if (/Firefox/i.test(ua)) {

      return 'Firefox';

    }



    return 'Other';

  }



  function getOS() {

    const ua = navigator.userAgent || '';



    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';

    if (/Android/i.test(ua)) return 'Android';

    if (/Windows/i.test(ua)) return 'Windows';

    if (/Mac OS X|Macintosh/i.test(ua)) return 'macOS';



    return 'Other';

  }



  function getUTMs() {

    const params =

      new URLSearchParams(

        window.location.search

      );



    return {

      utm_source:

        params.get('utm_source') || null,



      utm_medium:

        params.get('utm_medium') || null,



      utm_campaign:

        params.get('utm_campaign') || null,



      utm_content:

        params.get('utm_content') || null,



      utm_term:

        params.get('utm_term') || null

    };

  }



  function getReferrerHost() {

    if (!document.referrer) return null;



    try {

      return new URL(document.referrer).hostname;

    } catch (_) {

      return null;

    }

  }



  function getOrCreateAttribution() {

    let attribution =

      safeParse(

        safeStorageGet(

          localStorage,

          ATTRIBUTION_KEY

        ),

        null

      );



    const utms = getUTMs();

    const referrer =

      getReferrerHost();



    const hasCampaign =

      utms.utm_source ||

      utms.utm_medium ||

      utms.utm_campaign ||

      utms.utm_content ||

      utms.utm_term;



    if (!attribution) {

      attribution = {

        first_touch_at:

          new Date().toISOString(),



        landing_page:

          window.location.pathname +

          window.location.search,



        referrer: referrer,



        utm_source:

          utms.utm_source,



        utm_medium:

          utms.utm_medium,



        utm_campaign:

          utms.utm_campaign,



        utm_content:

          utms.utm_content,



        utm_term:

          utms.utm_term

      };



      safeStorageSet(

        localStorage,

        ATTRIBUTION_KEY,

        JSON.stringify(attribution)

      );

    }



    if (hasCampaign) {

      attribution.last_touch_at =

        new Date().toISOString();



      attribution.last_utm_source =

        utms.utm_source;



      attribution.last_utm_medium =

        utms.utm_medium;



      attribution.last_utm_campaign =

        utms.utm_campaign;



      attribution.last_utm_content =

        utms.utm_content;



      attribution.last_utm_term =

        utms.utm_term;



      safeStorageSet(

        localStorage,

        ATTRIBUTION_KEY,

        JSON.stringify(attribution)

      );

    }



    return attribution || {};

  }



  function getOrCreateSession() {

    const ts = now();



    let session =

      safeParse(

        safeStorageGet(

          localStorage,

          SESSION_KEY

        ),

        null

      );



    if (

      !session ||

      !session.id ||

      !session.last_activity ||

      ts - session.last_activity >

        SESSION_TIMEOUT_MS

    ) {

      session = {

        id:

          'BOPS-' + uuid(),



        started_at: ts,



        last_activity: ts,



        previous_event_at: ts

      };

    }



    session.last_activity = ts;



    safeStorageSet(

      localStorage,

      SESSION_KEY,

      JSON.stringify(session)

    );



    return session;

  }



  function saveSession(session) {

    safeStorageSet(

      localStorage,

      SESSION_KEY,

      JSON.stringify(session)

    );

  }



  function createConfiguration(

    productType

  ) {

    const configuration = {

      id:

        'BOPC-' + uuid(),



      product_type:

        productType || 'unknown',



      created_at:

        now(),



      changes: [],



      selected_sizes: {},



      kg_by_size: {}

    };



    safeStorageSet(

      sessionStorage,

      CONFIG_PREFIX + productType,

      JSON.stringify(configuration)

    );



    return configuration;

  }



  function getConfiguration(

    productType

  ) {

    const key =

      CONFIG_PREFIX +

      (productType || 'unknown');



    let configuration =

      safeParse(

        safeStorageGet(

          sessionStorage,

          key

        ),

        null

      );



    if (

      !configuration ||

      !configuration.id

    ) {

      configuration =

        createConfiguration(

          productType || 'unknown'

        );

    }



    if (

      !configuration.selected_sizes

    ) {

      configuration.selected_sizes = {};

    }



    if (!configuration.kg_by_size) {

      configuration.kg_by_size = {};

    }



    if (

      !Array.isArray(

        configuration.changes

      )

    ) {

      configuration.changes = [];

    }



    return configuration;

  }



  function saveConfiguration(

    productType,

    configuration

  ) {

    safeStorageSet(

      sessionStorage,

      CONFIG_PREFIX +

        (productType || 'unknown'),

      JSON.stringify(configuration)

    );

  }



  function addChange(

    productType,

    text

  ) {

    if (!text) return;



    const config =

      getConfiguration(

        productType

      );



    config.changes.push({

      at: now(),

      text: String(text)

    });



    if (

      config.changes.length > 50

    ) {

      config.changes =

        config.changes.slice(-50);

    }



    saveConfiguration(

      productType,

      config

    );

  }



  function getChangeSummary(

    productType

  ) {

    const config =

      getConfiguration(

        productType

      );



    return config.changes

      .map(function(item) {

        return item.text;

      })

      .join(' | ')

      .slice(0, 1500);

  }



  function buildSizeKey(payload) {

    const name =

      String(

        payload.size_name || ''

      ).trim();



    const dimensions =

      String(

        payload.dimensions || ''

      ).trim();



    if (!name) {

      return '';

    }



    if (dimensions) {

      return (

        name +

        ' ' +

        dimensions

      );

    }



    return name;

  }



  function updateConfigurationState(

    eventName,

    payload,

    productType

  ) {

    const config =

      getConfiguration(

        productType

      );



    if (

      eventName ===

      'bop_size_changed'

    ) {

      const key =

        buildSizeKey(payload);



      if (key) {

        if (

          payload.selected === true

        ) {

          config.selected_sizes[key] = {

            name:

              payload.size_name ||

              key,



            dimensions:

              payload.dimensions ||

              null

          };



          if (

            typeof

              config.kg_by_size[key] ===

            'undefined'

          ) {

            config.kg_by_size[key] =

              Number(

                payload.kg || 10

              );

          }

        }



        if (

          payload.selected === false

        ) {

          delete config.selected_sizes[

            key

          ];



          delete config.kg_by_size[

            key

          ];

        }

      }

    }



    if (

      eventName ===

      'bop_kg_changed'

    ) {

      const key =

        buildSizeKey(payload);



      if (key) {

        config.kg_by_size[key] =

          Number(

            payload.new_kg ||

            payload.kg ||

            0

          );



        if (

          !config.selected_sizes[key]

        ) {

          config.selected_sizes[key] = {

            name:

              payload.size_name ||

              key,



            dimensions:

              payload.dimensions ||

              null

          };

        }

      }

    }



    saveConfiguration(

      productType,

      config

    );



    return config;

  }



  function getSelectedSizesText(

    productType

  ) {

    const config =

      getConfiguration(

        productType

      );



    return Object.keys(

      config.selected_sizes || {}

    ).join(' | ');

  }



  function getSelectedSizesWithKgText(

    productType

  ) {

    const config =

      getConfiguration(

        productType

      );



    const keys =

      Object.keys(

        config.selected_sizes || {}

      );



    return keys

      .map(function(key) {

        const kg =

          Number(

            config.kg_by_size[key] || 0

          );



        if (kg > 0) {

          return (

            key +

            ' ' +

            kg +

            'kg'

          );

        }



        return key;

      })

      .join(' | ');

  }



  function getSelectedSizesCount(

    productType

  ) {

    const config =

      getConfiguration(

        productType

      );



    return Object.keys(

      config.selected_sizes || {}

    ).length;

  }



  function milestoneKey(

    configurationId,

    eventName

  ) {

    return (

      MILESTONE_PREFIX +

      configurationId +

      '_' +

      eventName

    );

  }



  function hasMilestone(

    configurationId,

    eventName

  ) {

    return (

      safeStorageGet(

        sessionStorage,

        milestoneKey(

          configurationId,

          eventName

        )

      ) === '1'

    );

  }



  function setMilestone(

    configurationId,

    eventName

  ) {

    safeStorageSet(

      sessionStorage,

      milestoneKey(

        configurationId,

        eventName

      ),

      '1'

    );

  }



  const FORBIDDEN_KEYS = [

    'email',

    'phone',

    'telephone',

    'address',

    'customer_name',

    'business_name',

    'logo',

    'logo_url',

    'logo_name',

    'filename',

    'instructions',

    'card',

    'payment'

  ];



  function cleanPayload(payload) {

    const clean = {};



    Object.keys(

      payload || {}

    ).forEach(function(key) {

      const lower =

        String(key)

          .toLowerCase();



      if (

        FORBIDDEN_KEYS.indexOf(

          lower

        ) !== -1

      ) {

        return;

      }



      const value =

        payload[key];



      if (

        value === null ||

        typeof value ===

          'undefined'

      ) {

        return;

      }



      if (

        typeof value === 'string'

      ) {

        clean[key] =

          value.slice(0, 500);



        return;

      }



      if (

        typeof value === 'number' ||

        typeof value === 'boolean'

      ) {

        clean[key] = value;



        return;

      }



      if (

        Array.isArray(value)

      ) {

        clean[key] =

          value

            .map(function(item) {

              if (

                typeof item ===

                'string'

              ) {

                return item;

              }



              if (

                item &&

                typeof item ===

                  'object'

              ) {

                return JSON.stringify(

                  item

                );

              }



              return String(item);

            })

            .join(' | ')

            .slice(0, 500);



        return;

      }

    });



    return clean;

  }



  function appendLocalEvent(

    eventObject

  ) {

    let log =

      safeParse(

        safeStorageGet(

          localStorage,

          EVENT_LOG_KEY

        ),

        []

      );



    if (!Array.isArray(log)) {

      log = [];

    }



    log.push(eventObject);



    if (

      log.length >

      MAX_LOCAL_EVENTS

    ) {

      log =

        log.slice(

          -MAX_LOCAL_EVENTS

        );

    }



    safeStorageSet(

      localStorage,

      EVENT_LOG_KEY,

      JSON.stringify(log)

    );

  }



  function canPublishToShopify() {

    return (

      window.Shopify &&

      Shopify.analytics &&

      typeof

        Shopify.analytics.publish ===

        'function'

    );

  }



  function actuallyPublish(

    eventName,

    payload

  ) {

    try {

      Shopify.analytics.publish(

        eventName,

        payload

      );



      return true;

    } catch (error) {

      if (

        window.BopAnalytics &&

        window.BopAnalytics.debug

      ) {

        console.warn(

          '[BopAnalytics] publish error',

          error

        );

      }



      return false;

    }

  }



  function flushPublishQueue() {

    if (!canPublishToShopify()) {

      return false;

    }



    if (

      !publishQueue.length

    ) {

      return true;

    }



    const pending =

      publishQueue.slice();



    publishQueue = [];



    pending.forEach(

      function(item) {

        actuallyPublish(

          item.name,

          item.payload

        );

      }

    );



    return true;

  }



  function scheduleQueueFlush() {

    if (publishTimer) {

      return;

    }



    let attempts = 0;



    publishTimer =

      window.setInterval(

        function() {

          attempts += 1;



          if (

            flushPublishQueue()

          ) {

            clearInterval(

              publishTimer

            );



            publishTimer = null;

            return;

          }



          if (attempts >= 40) {

            clearInterval(

              publishTimer

            );



            publishTimer = null;

          }

        },

        250

      );

  }



  function publishToShopify(

    eventName,

    payload

  ) {

    if (

      canPublishToShopify()

    ) {

      actuallyPublish(

        eventName,

        payload

      );



      return;

    }



    publishQueue.push({

      name: eventName,

      payload: payload

    });



    scheduleQueueFlush();

  }



  function pushToDataLayer(

    eventName,

    payload

  ) {

    try {

      if (

        Array.isArray(

          window.dataLayer

        )

      ) {

        window.dataLayer.push({

          event: eventName,

          ...payload

        });

      }

    } catch (_) {}

  }



  function track(

    eventName,

    payload,

    options

  ) {

    payload =

      payload || {};



    options =

      options || {};



    const session =

      getOrCreateSession();



    const productType =

      payload.product_type ||

      options.productType ||

      'unknown';



    let config =

      getConfiguration(

        productType

      );



    config =

      updateConfigurationState(

        eventName,

        payload,

        productType

      );



    const requestedConfigurationId =

      options.configurationId ||

      options.configuration_id ||

      null;



    const eventConfigurationId =

      requestedConfigurationId &&

      /^BOPC-[A-Za-z0-9-]+$/.test(

        String(requestedConfigurationId)

      )

        ? String(requestedConfigurationId)

        : config.id;



    const milestone =

      options.milestone === true;



    if (

      milestone &&

      hasMilestone(

        eventConfigurationId,

        eventName

      )

    ) {

      return null;

    }



    const ts = now();



    const attribution =

      getOrCreateAttribution();



    const clean =

      cleanPayload(payload);



    const selectedSizes =

      getSelectedSizesText(

        productType

      );



    const selectedWithKg =

      getSelectedSizesWithKgText(

        productType

      );



    const selectedCount =

      getSelectedSizesCount(

        productType

      );



    if (selectedSizes) {

      clean.selected_sizes =

        selectedSizes;



      clean.selected_sizes_count =

        selectedCount;

    }



    if (selectedWithKg) {

      clean.selected_sizes_with_kg =

        selectedWithKg;

    }



    const eventObject = {

      event_name:

        eventName,



      event_id:

        'BOPE-' + uuid(),



      analytics_version:

        VERSION,



      bop_session_id:

        session.id,



      configuration_id:

        eventConfigurationId,



      timestamp:

        new Date(

          ts

        ).toISOString(),



      time_since_session_start_ms:

        ts -

        session.started_at,



      time_since_previous_event_ms:

        ts -

        (

          session.previous_event_at ||

          session.started_at

        ),



      page_path:

        window.location.pathname,



      page_title:

        document.title || null,



      device_category:

        getDeviceCategory(),



      browser:

        getBrowser(),



      os:

        getOS(),



      screen_width:

        window.innerWidth || null,



      screen_height:

        window.innerHeight || null,



      referrer:

        attribution.referrer ||

        null,



      landing_page:

        attribution.landing_page ||

        null,



      utm_source:

        attribution.utm_source ||

        null,



      utm_medium:

        attribution.utm_medium ||

        null,



      utm_campaign:

        attribution.utm_campaign ||

        null,



      utm_content:

        attribution.utm_content ||

        null,



      utm_term:

        attribution.utm_term ||

        null,



      last_utm_source:

        attribution.last_utm_source ||

        null,



      last_utm_medium:

        attribution.last_utm_medium ||

        null,



      last_utm_campaign:

        attribution.last_utm_campaign ||

        null,



      ...clean

    };



    session.previous_event_at =

      ts;



    session.last_activity =

      ts;



    saveSession(

      session

    );



    if (milestone) {

      setMilestone(

        eventConfigurationId,

        eventName

      );

    }



    appendLocalEvent(

      eventObject

    );



    publishToShopify(

      eventName,

      eventObject

    );



    pushToDataLayer(

      eventName,

      eventObject

    );



    if (

      window.BopAnalytics &&

      window.BopAnalytics.debug

    ) {

      console.log(

        '[BopAnalytics]',

        eventName,

        eventObject

      );

    }



    return eventObject;

  }



  function getSnapshot(

    productType

  ) {

    const session =

      getOrCreateSession();



    const config =

      getConfiguration(

        productType

      );



    const attribution =

      getOrCreateAttribution();



    return {

      analytics_version:

        VERSION,



      bop_session_id:

        session.id,



      configuration_id:

        config.id,



      product_type:

        productType,



      device_category:

        getDeviceCategory(),



      browser:

        getBrowser(),



      os:

        getOS(),



      landing_page:

        attribution.landing_page ||

        null,



      referrer:

        attribution.referrer ||

        null,



      utm_source:

        attribution.utm_source ||

        null,



      utm_medium:

        attribution.utm_medium ||

        null,



      utm_campaign:

        attribution.utm_campaign ||

        null,



      utm_content:

        attribution.utm_content ||

        null,



      utm_term:

        attribution.utm_term ||

        null,



      selected_sizes:

        getSelectedSizesText(

          productType

        ),



      selected_sizes_with_kg:

        getSelectedSizesWithKgText(

          productType

        ),



      selected_sizes_count:

        getSelectedSizesCount(

          productType

        ),



      configuration_changes_summary:

        getChangeSummary(

          productType

        )

    };

  }



  function getEvents() {

    const events =

      safeParse(

        safeStorageGet(

          localStorage,

          EVENT_LOG_KEY

        ),

        []

      );



    return Array.isArray(events)

      ? events

      : [];

  }



  window.BopAnalytics = {

    version: VERSION,



    debug:

      new URLSearchParams(

        window.location.search

      ).get('bop_debug') === '1',



    track: track,



    addChange: addChange,



    getSnapshot:

      getSnapshot,



    getEvents:

      getEvents,



    getSessionId:

      function() {

        return (

          getOrCreateSession().id

        );

      },



    getConfigurationId:

      function(productType) {

        return getConfiguration(

          productType

        ).id;

      },



    newConfiguration:

      function(productType) {

        return createConfiguration(

          productType

        );

      }

  };



  function detectProduct(

    pathname

  ) {

    const path =

      String(

        pathname || ''

      ).toLowerCase();



    if (

      path.indexOf(

        'boutique'

      ) !== -1

    ) {

      return 'boutique';

    }



    if (

      path.indexOf(

        'camiseta'

      ) !== -1

    ) {

      return 'camiseta';

    }



    if (

      path.indexOf(

        'hielo'

      ) !== -1

    ) {

      return 'hielo';

    }



    return null;

  }



  function detectPlacement(

    element

  ) {

    if (!element) {

      return 'unknown';

    }



    if (

      element.closest('header')

    ) {

      return 'header';

    }



    if (

      element.closest('footer')

    ) {

      return 'footer';

    }



    if (

      window.location.pathname ===

      '/'

    ) {

      return 'homepage';

    }



    return 'page';

  }



  document.addEventListener(

    'click',

    function(event) {

      let target =

        event.target;



      if (

        target &&

        target.nodeType !== 1

      ) {

        target =

          target.parentElement;

      }



      if (

        !target ||

        !target.closest

      ) {

        return;

      }



      const link =

        target.closest(

          'a[href]'

        );



      if (!link) {

        return;

      }



      let destination;



      try {

        destination =

          new URL(

            link.href,

            window.location.origin

          );

      } catch (_) {

        return;

      }



      if (

        destination.origin !==

        window.location.origin

      ) {

        return;

      }



      const productType =

        detectProduct(

          destination.pathname

        );



      if (!productType) {

        return;

      }



      track(

        'bop_product_clicked',

        {

          product_type:

            productType,



          placement:

            detectPlacement(

              link

            ),



          destination:

            destination.pathname

        },

        {

          productType:

            productType

        }

      );

    },

    true

  );



  function trackCurrentProductView() {

    const productType =

      detectProduct(

        window.location.pathname

      );



    if (!productType) {

      return;

    }



    track(

      'bop_product_viewed',

      {

        product_type:

          productType,



        step:

          'product'

      },

      {

        productType:

          productType,



        milestone:

          true

      }

    );

  }



  function trackCartView() {

    let path =

      window.location.pathname;



    if (

      path !== '/cart' &&

      path !== '/cart/'

    ) {

      return;

    }



    let cart = [];



    try {

      const raw =

        localStorage.getItem(

          'bmx_cart'

        );



      const parsed =

        raw

          ? JSON.parse(raw)

          : [];



      if (

        Array.isArray(parsed)

      ) {

        cart = parsed;

      }

    } catch (_) {

      cart = [];

    }



    let totalKg = 0;

    let subtotal = 0;



    let boutiqueItems = 0;

    let camisetaItems = 0;

    let hieloItems = 0;



    const measureTexts = [];



    const configurationIds = [];



    cart.forEach(

      function(item) {

        totalKg +=

          Number(

            item.totalKg || 0

          );



        subtotal +=

          Number(

            item.total || 0

          );



        if (

          item.productFamily ===

          'boutique'

        ) {

          boutiqueItems += 1;

        }



        if (

          item.productFamily ===

          'camiseta'

        ) {

          camisetaItems += 1;

        }



        if (

          item.productFamily ===

          'hielo'

        ) {

          hieloItems += 1;

        }



        const itemConfigurationId =

          item.configurationId ||

          item.configuration_id ||

          '';



        if (

          itemConfigurationId &&

          configurationIds.indexOf(

            String(itemConfigurationId)

          ) === -1

        ) {

          configurationIds.push(

            String(itemConfigurationId)

          );

        }



        if (

          Array.isArray(

            item.measures

          )

        ) {

          item.measures.forEach(

            function(measure) {

              if (

                measure &&

                measure.name

              ) {

                measureTexts.push(

                  measure.name +

                  ' ' +

                  Number(

                    measure.kg || 0

                  ) +

                  'kg'

                );

              }

            }

          );

        }

      }

    );



    track(

      'bop_cart_viewed',

      {

        product_type:

          'cart',



        step:

          'cart',



        cart_item_count:

          cart.length,



        total_kg:

          totalKg,



        displayed_subtotal:

          subtotal,



        boutique_items:

          boutiqueItems,



        camiseta_items:

          camisetaItems,



        hielo_items:

          hieloItems,



        selected_measures:

          measureTexts

            .join(' | ')

            .slice(0, 500),



        configuration_ids:

          configurationIds

            .join(' | ')

            .slice(0, 500),



        configuration_count:

          configurationIds.length

      },

      {

        productType:

          'cart',



        configurationId:

          configurationIds.length === 1

            ? configurationIds[0]

            : null,



        milestone:

          true

      }

    );

  }



  document.addEventListener(

    'click',

    function(event) {

      let target =

        event.target;



      if (

        target &&

        target.nodeType !== 1

      ) {

        target =

          target.parentElement;

      }



      if (

        !target ||

        !target.closest

      ) {

        return;

      }



      const link =

        target.closest(

          'a[href]'

        );



      if (!link) {

        return;

      }



      const href =

        String(

          link.getAttribute(

            'href'

          ) || ''

        ).toLowerCase();



      if (

        href.indexOf(

          'wa.me'

        ) === -1 &&

        href.indexOf(

          'whatsapp'

        ) === -1

      ) {

        return;

      }



      const currentProduct =

        detectProduct(

          window.location.pathname

        );



      track(

        'bop_whatsapp_clicked',

        {

          product_type:

            currentProduct ||

            'unknown',



          placement:

            detectPlacement(

              link

            )

        },

        {

          productType:

            currentProduct ||

            'unknown'

        }

      );

    },

    true

  );





  /* =========================================================

     HEADER ANALYTICS

     ========================================================= */



  function getHeaderArea(element) {

    if (!element || !element.closest) {

      return 'header';

    }



    if (element.closest('.bmx-header__drawer')) {

      return 'mobile_drawer';

    }



    if (element.closest('.bmx-header__desktop-nav')) {

      return 'desktop_nav';

    }



    if (element.closest('.bmx-header__desktop-account')) {

      return 'desktop_account';

    }



    if (element.closest('.bmx-header__mobile-account')) {

      return 'mobile_account';

    }



    if (element.closest('.bmx-header__actions')) {

      return 'header_actions';

    }



    return 'header';

  }



  function getCleanLinkText(element) {

    if (!element) {

      return '';

    }



    return String(

      element.textContent || ''

    )

      .replace(/\s+/g, ' ')

      .trim()

      .slice(0, 100);

  }



  function getHeaderDestination(link) {

    if (!link) {

      return '';

    }



    try {

      const url =

        new URL(

          link.href,

          window.location.origin

        );



      if (

        url.origin !==

        window.location.origin

      ) {

        return url.href.slice(0, 300);

      }



      return (

        url.pathname +

        url.search

      ).slice(0, 300);

    } catch (_) {

      return String(

        link.getAttribute('href') || ''

      ).slice(0, 300);

    }

  }



  function classifyHeaderLink(link) {

    if (!link) {

      return 'other';

    }



    const text =

      getCleanLinkText(link)

        .toLowerCase();



    const destination =

      getHeaderDestination(link)

        .toLowerCase();



    if (

      destination.indexOf('/pages/productos') !== -1 ||

      text === 'productos' ||

      text.indexOf('ver todos') !== -1 ||

      text.indexOf('todos los productos') !== -1

    ) {

      return 'all_products';

    }



    if (

      destination.indexOf('muestra') !== -1 ||

      text.indexOf('muestra') !== -1

    ) {

      return 'samples';

    }



    if (

      destination.indexOf('checa-tu-pedido') !== -1 ||

      text.indexOf('checa tu pedido') !== -1

    ) {

      return 'order_tracking';

    }



    if (

      destination.indexOf('/collections/all') !== -1 ||

      text.indexOf('oferta') !== -1

    ) {

      return 'offers';

    }



    if (

      link.classList.contains('bmx-header__mobile-pro') ||

      !!link.closest('.bmx-header__desktop-pro') ||

      destination.indexOf('/pages/pro') !== -1 ||

      text.indexOf('boplastemx black') !== -1

    ) {

      return 'black';

    }



    return 'other';

  }



  function getHeaderCartBadgeCount(header) {

    if (!header) {

      return 0;

    }



    const badge =

      header.querySelector(

        '[data-bmx-header-cart-count]'

      );



    if (

      !badge ||

      badge.hidden

    ) {

      return 0;

    }



    const parsed =

      parseInt(

        String(

          badge.textContent || '0'

        ),

        10

      );



    if (

      Number.isNaN(parsed)

    ) {

      return 0;

    }



    return parsed;

  }



  function initHeaderToggleTracking() {

    const menus =

      document.querySelectorAll(

        '.bmx-header__menu'

      );



    menus.forEach(

      function(menu) {

        if (

          menu.dataset.bopAnalyticsReady === '1'

        ) {

          return;

        }



        menu.dataset.bopAnalyticsReady = '1';



        menu.addEventListener(

          'toggle',

          function() {

            track(

              menu.open

                ? 'bop_header_menu_opened'

                : 'bop_header_menu_closed',

              {

                product_type:

                  'navigation',



                placement:

                  'header',



                header_area:

                  'mobile_drawer',



                menu_name:

                  'main_mobile_menu'

              },

              {

                productType:

                  'navigation'

              }

            );

          }

        );

      }

    );

  }



  document.addEventListener(

    'click',

    function(event) {

      let target =

        event.target;



      if (

        target &&

        target.nodeType !== 1

      ) {

        target =

          target.parentElement;

      }



      if (

        !target ||

        !target.closest

      ) {

        return;

      }



      const header =

        target.closest(

          '.bmx-header'

        );



      if (!header) {

        return;

      }



      /*

        DESKTOP DROPDOWN BUTTON

      */



      const dropdownButton =

        target.closest(

          '.bmx-header__desktop-trigger > button'

        );



      if (dropdownButton) {

        const label =

          String(

            dropdownButton.getAttribute(

              'aria-label'

            ) || 'Productos'

          )

            .replace(/^Abrir menú de\s*/i, '')

            .trim()

            .slice(0, 100);



        window.setTimeout(

          function() {

            const expanded =

              dropdownButton.getAttribute(

                'aria-expanded'

              ) === 'true';



            track(

              expanded

                ? 'bop_header_dropdown_opened'

                : 'bop_header_dropdown_closed',

              {

                product_type:

                  'navigation',



                placement:

                  'header',



                header_area:

                  'desktop_nav',



                dropdown_name:

                  label

              },

              {

                productType:

                  'navigation'

              }

            );

          },

          0

        );



        return;

      }



      const link =

        target.closest(

          'a[href]'

        );



      if (!link) {

        return;

      }



      const headerArea =

        getHeaderArea(link);



      const destination =

        getHeaderDestination(link);



      const linkText =

        getCleanLinkText(link);



      /*

        PRODUCT LINKS

        Ya los registra el listener global

        bop_product_clicked.

        No duplicarlos aquí.

      */



      let destinationPath = '';



      try {

        destinationPath =

          new URL(

            link.href,

            window.location.origin

          ).pathname;

      } catch (_) {}



      if (

        detectProduct(

          destinationPath

        )

      ) {

        return;

      }



      /*

        SEARCH

      */



      if (

        link.matches(

          '[data-bmx-search-open]'

        )

      ) {

        track(

          'bop_header_search_opened',

          {

            product_type:

              'navigation',



            placement:

              'header',



            header_area:

              headerArea,



            destination:

              destination

          },

          {

            productType:

              'navigation'

          }

        );



        return;

      }



      /*

        CART

      */



      if (

        link.matches(

          '[data-bmx-header-cart]'

        )

      ) {

        track(

          'bop_header_cart_clicked',

          {

            product_type:

              'cart',



            placement:

              'header',



            header_area:

              headerArea,



            cart_badge_count:

              getHeaderCartBadgeCount(

                header

              ),



            destination:

              destination

          },

          {

            productType:

              'cart'

          }

        );



        return;

      }



      /*

        LOGO / HOME

      */



      if (

        link.classList.contains(

          'bmx-header__logo'

        )

      ) {

        track(

          'bop_header_logo_clicked',

          {

            product_type:

              'navigation',



            placement:

              'header',



            header_area:

              headerArea,



            destination:

              destination

          },

          {

            productType:

              'navigation'

          }

        );



        return;

      }



      /*

        ACCOUNT

      */



      if (

        link.closest(

          '.bmx-header__desktop-account, .bmx-header__mobile-account'

        )

      ) {

        let action =

          'account';



        const lowerDestination =

          destination.toLowerCase();



        if (

          lowerDestination.indexOf(

            '/account/login'

          ) !== -1

        ) {

          action = 'login';

        }



        if (

          lowerDestination.indexOf(

            '/account/register'

          ) !== -1

        ) {

          action = 'register';

        }



        track(

          'bop_header_account_clicked',

          {

            product_type:

              'navigation',



            placement:

              'header',



            header_area:

              headerArea,



            account_action:

              action,



            link_text:

              linkText,



            destination:

              destination

          },

          {

            productType:

              'navigation'

          }

        );



        return;

      }



      /*

        REST OF HEADER LINKS:

        Productos, Muestras, Pedido,

        Ofertas, Black, etc.

      */



      track(

        'bop_header_link_clicked',

        {

          product_type:

            'navigation',



          placement:

            'header',



          header_area:

            headerArea,



          link_type:

            classifyHeaderLink(

              link

            ),



          link_text:

            linkText,



          destination:

            destination

        },

        {

          productType:

            'navigation'

        }

      );

    },

    true

  );



  function initializePageTracking() {

    flushPublishQueue();



    initHeaderToggleTracking();



    trackCurrentProductView();



    trackCartView();

  }



  document.addEventListener(

    'shopify:section:load',

    function() {

      initHeaderToggleTracking();

    }

  );



  if (

    document.readyState ===

    'loading'

  ) {

    document.addEventListener(

      'DOMContentLoaded',

      initializePageTracking,

      {

        once: true

      }

    );

  } else {

    initializePageTracking();

  }



  if (

    window.BopAnalytics.debug

  ) {

    console.log(

      '[BopAnalytics] initialized',

      VERSION

    );

  }



})();
